import { Menu } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import type { ReactElement } from 'react';

type InvoiceOtherActionsMenuProps = {
  trigger: ReactElement;
  canUseTasks: boolean;
  hasManualActions: boolean;
  canUnmatchPayment: boolean;
  canDelete: boolean;
  showIgnoreLateFees: boolean;
  canIgnoreLateFees: boolean;
  onNewTask: () => void;
  onEditSendingOptions: () => void;
  onDuplicate: () => void;
  onUnmatchPayment?: () => void;
  onDelete: () => void;
  onIgnoreLateFees: () => void;
};

export const InvoiceOtherActionsMenu = ({
  trigger,
  canUseTasks,
  hasManualActions,
  canUnmatchPayment,
  canDelete,
  showIgnoreLateFees,
  canIgnoreLateFees,
  onNewTask,
  onEditSendingOptions,
  onDuplicate,
  onUnmatchPayment,
  onDelete,
  onIgnoreLateFees,
}: InvoiceOtherActionsMenuProps) => {
  const { t } = useTranslation();

  return (
    <Menu position="bottom-end" width={260}>
      <Menu.Target>
        <div>{trigger}</div>
      </Menu.Target>
      <Menu.Dropdown>
        {canUseTasks && <Menu.Item onClick={onNewTask}>{t(i18nKeys.NEW_TASK)}</Menu.Item>}
        <Menu.Item onClick={onEditSendingOptions}>
          {t(i18nKeys.INVOICE.EDIT_SENDING_OPTIONS)}
        </Menu.Item>
        {hasManualActions && <Menu.Item onClick={onDuplicate}>{t(i18nKeys.DUPLICATE)}</Menu.Item>}
        {hasManualActions && (
          <Menu.Item disabled={!canUnmatchPayment} onClick={onUnmatchPayment}>
            {t(i18nKeys.INVOICE.UNMATCH_PAYMENT.UNMATCH_PAYMENT)}
          </Menu.Item>
        )}
        {hasManualActions && (
          <Menu.Item disabled={!canDelete} onClick={onDelete}>
            {t(i18nKeys.DELETE)}
          </Menu.Item>
        )}
        {showIgnoreLateFees && (
          <Menu.Item disabled={!canIgnoreLateFees} onClick={onIgnoreLateFees}>
            {t(i18nKeys.IGNORE_LATE_FEES)}
          </Menu.Item>
        )}
      </Menu.Dropdown>
    </Menu>
  );
};
